var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildindIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_714_735)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.499 33.7473V6.24734C22.499 5.91582 22.3673 5.59788 22.1328 5.36346C21.8984 5.12904 21.5805 4.99734 21.249 4.99734H6.24896C5.91744 4.99734 5.5995 5.12904 5.36508 5.36346C5.13066 5.59788 4.99896 5.91582 4.99896 6.24734V33.7473",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 33.7474H37.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.499 33.7473V6.24734C22.499 5.91582 22.3673 5.59788 22.1328 5.36346C21.8984 5.12904 21.5805 4.99734 21.249 4.99734H6.24896C5.91744 4.99734 5.5995 5.12904 5.36508 5.36346C5.13066 5.59788 4.99896 5.91582 4.99896 6.24734V33.7473",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.999 33.7473V16.2473C34.999 15.9158 34.8673 15.5979 34.6329 15.3634C34.3984 15.129 34.0805 14.9973 33.749 14.9973H22.499",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99896 11.2473H14.999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.499 21.2474H17.499",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99896 27.4974H14.999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.499 27.4974H29.999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.499 21.2474H29.999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_714_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildindIconWhite);
export default __webpack_public_path__ + "static/media/buildindIconWhite.a440f9a64b4d46345f7a2ee5e5ae5507.svg";
export { ForwardRef as ReactComponent };